export default __webpack_public_path__ + "static/media/Beard_3_C1.c8d9f27c.svg";